// International countries and their provinces/states

export const COUNTRIES = [
  { code: "CA", name: "Canada" },
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "AU", name: "Australia" },
  { code: "PK", name: "Pakistan" },
  { code: "IN", name: "India" },
  { code: "BD", name: "Bangladesh" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "MY", name: "Malaysia" },
  { code: "TR", name: "Turkey" },
  { code: "EG", name: "Egypt" },
  { code: "ID", name: "Indonesia" },
  { code: "NG", name: "Nigeria" },
  { code: "ZA", name: "South Africa" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "NL", name: "Netherlands" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "OTHER", name: "Other" }
];

export const PROVINCES_BY_COUNTRY = {
  CA: [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Northwest Territories",
    "Nova Scotia",
    "Nunavut",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Yukon"
  ],
  US: [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
    "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
    "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
    "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
    "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
    "New Hampshire", "New Jersey", "New Mexico", "New York",
    "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
    "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
    "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
    "West Virginia", "Wisconsin", "Wyoming"
  ],
  GB: [
    "England",
    "Scotland",
    "Wales",
    "Northern Ireland"
  ],
  AU: [
    "Australian Capital Territory",
    "New South Wales",
    "Northern Territory",
    "Queensland",
    "South Australia",
    "Tasmania",
    "Victoria",
    "Western Australia"
  ],
  PK: [
    "Balochistan",
    "Khyber Pakhtunkhwa",
    "Punjab",
    "Sindh",
    "Islamabad Capital Territory",
    "Azad Kashmir",
    "Gilgit-Baltistan"
  ],
  IN: [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Delhi", "Jammu and Kashmir", "Ladakh"
  ],
  BD: [
    "Barisal", "Chittagong", "Dhaka", "Khulna", "Mymensingh",
    "Rajshahi", "Rangpur", "Sylhet"
  ],
  SA: [
    "Riyadh", "Makkah", "Madinah", "Eastern Province", "Asir",
    "Tabuk", "Qassim", "Ha'il", "Jizan", "Najran", "Al-Baha",
    "Northern Borders", "Jawf", "Al-Qurayyat"
  ],
  AE: [
    "Abu Dhabi",
    "Dubai",
    "Sharjah",
    "Ajman",
    "Umm Al-Quwain",
    "Ras Al-Khaimah",
    "Fujairah"
  ],
  MY: [
    "Johor", "Kedah", "Kelantan", "Malacca", "Negeri Sembilan",
    "Pahang", "Penang", "Perak", "Perlis", "Sabah", "Sarawak",
    "Selangor", "Terengganu", "Kuala Lumpur", "Labuan", "Putrajaya"
  ],
  TR: [
    "Istanbul", "Ankara", "Izmir", "Bursa", "Antalya", "Adana",
    "Konya", "Gaziantep", "Mersin", "Kayseri", "Diyarbakir", "Other"
  ],
  EG: [
    "Cairo", "Alexandria", "Giza", "Qalyubia", "Port Said", "Suez",
    "Dakahlia", "Sharqia", "Gharbia", "Monufia", "Other"
  ],
  ID: [
    "Jakarta", "West Java", "East Java", "Central Java", "Banten",
    "North Sumatra", "South Sumatra", "Lampung", "Bali", "Other"
  ],
  NG: [
    "Lagos", "Kano", "Rivers", "Kaduna", "Oyo", "Abuja",
    "Delta", "Ogun", "Edo", "Anambra", "Other"
  ],
  ZA: [
    "Gauteng", "Western Cape", "KwaZulu-Natal", "Eastern Cape",
    "Limpopo", "Mpumalanga", "North West", "Free State", "Northern Cape"
  ],
  FR: [
    "Île-de-France", "Provence-Alpes-Côte d'Azur", "Auvergne-Rhône-Alpes",
    "Nouvelle-Aquitaine", "Occitanie", "Hauts-de-France", "Pays de la Loire",
    "Brittany", "Normandy", "Grand Est", "Bourgogne-Franche-Comté",
    "Centre-Val de Loire", "Corsica"
  ],
  DE: [
    "Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen",
    "Hamburg", "Hesse", "Lower Saxony", "Mecklenburg-Vorpommern",
    "North Rhine-Westphalia", "Rhineland-Palatinate", "Saarland",
    "Saxony", "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia"
  ],
  NL: [
    "North Holland", "South Holland", "Utrecht", "North Brabant",
    "Gelderland", "Limburg", "Groningen", "Friesland", "Zeeland",
    "Overijssel", "Flevoland", "Drenthe"
  ],
  SE: [
    "Stockholm", "Västra Götaland", "Skåne", "Uppsala", "Östergötland",
    "Jönköping", "Halland", "Örebro", "Södermanland", "Other"
  ],
  NO: [
    "Oslo", "Viken", "Innlandet", "Vestfold og Telemark", "Agder",
    "Rogaland", "Vestland", "Møre og Romsdal", "Trøndelag",
    "Nordland", "Troms og Finnmark"
  ],
  OTHER: ["Other"]
};

// Major cities by province (for verification page)
export const CITIES_BY_PROVINCE = {
  // Canada
  "Ontario": ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Markham", "Vaughan", "Kitchener", "Windsor", "Other"],
  "British Columbia": ["Vancouver", "Surrey", "Burnaby", "Richmond", "Abbotsford", "Coquitlam", "Kelowna", "Victoria", "Other"],
  "Alberta": ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "St. Albert", "Medicine Hat", "Grande Prairie", "Other"],
  "Quebec": ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke", "Saguenay", "Trois-Rivières", "Other"],
  
  // USA (major cities per state - showing only few examples)
  "California": ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento", "Fresno", "Oakland", "Other"],
  "New York": ["New York City", "Buffalo", "Rochester", "Yonkers", "Syracuse", "Albany", "New Rochelle", "Other"],
  "Texas": ["Houston", "Dallas", "Austin", "San Antonio", "Fort Worth", "El Paso", "Arlington", "Other"],
  "Florida": ["Miami", "Orlando", "Tampa", "Jacksonville", "Fort Lauderdale", "Tallahassee", "Other"],
  
  // Pakistan
  "Punjab": ["Lahore", "Faisalabad", "Rawalpindi", "Multan", "Gujranwala", "Sialkot", "Bahawalpur", "Other"],
  "Sindh": ["Karachi", "Hyderabad", "Sukkur", "Larkana", "Mirpur Khas", "Nawabshah", "Other"],
  "Khyber Pakhtunkhwa": ["Peshawar", "Mardan", "Abbottabad", "Mingora", "Kohat", "Dera Ismail Khan", "Other"],
  
  // Default for provinces without specific cities
  "DEFAULT": ["Other"]
};

// Helper function to get provinces for a country
export const getProvincesForCountry = (countryCode) => {
  return PROVINCES_BY_COUNTRY[countryCode] || ["Other"];
};

// Helper function to get cities for a province
export const getCitiesForProvince = (province) => {
  return CITIES_BY_PROVINCE[province] || CITIES_BY_PROVINCE["DEFAULT"];
};
